import './AboutMe.css';
import React from 'react';
import { Link } from 'react-router-dom';
import { BsCloudDownload } from 'react-icons/bs';

const AboutMe = () => {
  return (
    <div className="AboutMe">
      <div className="about_info_container">
        <div className="personal_info">
          <h3 className="mb-4">PERSONAL <span style={{ color: 'orange' }}>INFOS</span></h3>
          <div className="info_details">
            <div className="mr-3">
              <p><span className="text-secondary">Full Name:</span> Ahsanul Kabir</p>
              <p><span className="text-secondary">Address:</span> Chattogram</p>
              <p><span className="text-secondary">Nationality:</span> Bangladeshi</p>
              {/* <p><span className="text-secondary">Intern:</span> <a href="https://www.linkedin.com/company/qubit-capital/mycompany/" target="blank" className="intern_link">Qubit Capital</a></p> */}
              {/* <p><span className="text-secondary">Remote Work:</span> Open To Work</p> */}
              <p><span className="text-secondary">Full Time Work:</span> Open To Work</p>
            </div>
            <div>
              <p><span className="text-secondary">Email:</span> ahsanul.kabir.cse@gmail.com</p>
              <p><span className="text-secondary">Language:</span> Bangla, English, Hindi</p>
              <p><span className="text-secondary">Mobile:</span> +8801753652153</p>
              <p><span className="text-secondary">Mobile:</span> +8801571416281</p>
            </div>
          </div>
          <div>
            <Link to="/projects" className="cus_btn">Recent Projects</Link>
            <a href="https://drive.google.com/u/0/uc?id=1KKya1GeGvmL9CiuZdboOb4lqdBXFUVBo&export=download" className="cus_btn" download>Resume <BsCloudDownload /></a>
          </div>
        </div>
        <div className="work_experience">
          <h3 className="mb-4"><span style={{ color: 'orange' }}>WORK</span> EXPERIENCE</h3>
          <div className="experience_container">
            <div className="experience_box">
              <h1 className="exp_number">1<sup>+</sup></h1>
              <p className="pl-4 mb-0">Work <br /> Experience (Self)</p>
            </div>

            <div className="experience_box">
              <h1 className="exp_number">10<sup>+</sup></h1>
              <p className="pl-4 mb-0">Projects <br /> Completed</p>
            </div>

            <div className="experience_box">
              <h1 className="exp_number">1<sup>+</sup></h1>
              <p className="pl-4 mb-0">Projects <br /> On Going</p>
            </div>

            <div className="experience_box">
              <h1 className="exp_number">1<sup>+</sup></h1>
              <p className="pl-4 mb-0">Won <br /> Rewards</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;